import { HiOutlineBell } from 'react-icons/hi2'
import moment from 'moment/moment'

import { Dropdown } from 'Components/Ui'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getNotificationData, readNotificationData } from 'Store/auth/notificationSlice'

const Notifications = () => {
    const dispatch = useDispatch()
    const { user } = useSelector(state => state.auth)
    const notifications = useSelector(state => state.notification)

    useEffect(() => {
        if (user) {
            dispatch(getNotificationData(user.guard))
        }
        // eslint-disable-next-line
    }, [])

    const readNotification = () => {
        if (!user || notifications.length === 0) return
        dispatch(readNotificationData(user.guard))
    }

    return (
        <Dropdown>
            <Dropdown.Trigger downShow={false}>
                <div className="relative flex items-center justify-center w-8 h-8 border rounded-full cursor-pointer border-stroke bg-gray hover:text-primary dark:hover:text-secondary dark:border-strokedark dark:bg-graydark dark:text-white">
                    {notifications.length !== 0 && (
                        <span className="absolute right-0 w-2 h-2 rounded-full -top-1 bg-danger">
                            <span className="absolute right-0 inline-flex w-full h-full rounded-full opacity-75 animate-ping bg-danger"></span>
                        </span>
                    )}
                    <HiOutlineBell size={20} />
                </div>
            </Dropdown.Trigger>
            <Dropdown.Content width="80" contentClasses="max-h-96" className="-right-20 sm:right-0">
                <div className="flex flex-row items-center justify-between gap-3 px-5 py-3">
                    <h5 className="text-sm font-bold">Notification</h5>
                    {notifications.length !== 0 && (
                        <p onClick={readNotification} className="cursor-pointer hover:text-primary dark:hover:text-secondary">
                            Clear
                        </p>
                    )}
                </div>
                <ul className="flex flex-col h-auto overflow-y-auto">
                    {notifications.map((row, index) => (
                        <li key={index}>
                            <div className="flex flex-col gap-2.5 border-t border-stroke px-4 py-3 hover:bg-gray dark:border-strokedark dark:hover:bg-graydark">
                                <p className="text-sm">{row.data.message}</p>
                                <p className="text-xs">{moment(row.created_at).fromNow()}</p>
                            </div>
                        </li>
                    ))}
                    {notifications.length === 0 && (
                        <li>
                            <div className="items-center px-4 py-3 text-center border-t border-stroke dark:border-strokedark text-primary dark:text-white">
                                Data not found
                            </div>
                        </li>
                    )}
                </ul>
            </Dropdown.Content>
        </Dropdown>
    )
}

export default Notifications
